import type { LDFlagSet, LDUser } from 'launchdarkly-js-client-sdk';

export interface FFUser extends LDUser {
  /** User UUID / Device UUID etc */
  key: string;
  /** User Name if aplicable */
  name: string;
  /** Additional Data */
  custom?: {
    applicationName: string /** From DMS ww.kux.telenor.android */;
    consumerEmail: string /** have to be updated after login **/;
    deviceBrand: string;
    deviceFamily: string /** From DMS ww.kux.telenor.android */;
    firmware: string;
    clientTag: string;
    clientVersion: string /** 1.0.1    0.12.0.  0.13.0 **/;
    osVersion: string;
    partnerId: string /** 3200 / 3207 */;
    release: string;
    tvpilVersion: string;
    platform: string;
  };
}

export interface LaunchDarklyApiKeys {
  sdk?: string;
  mobile?: string;
}

/**
 * Abstract class for launchdarkly client
 */
export abstract class LaunchdarklyClient {
  /**
   * Initialize Launchdarkly
   *
   * @param keys - sdk (for js client) or mobile (for RN)
   * @param user - FFUser
   */
  abstract initialize(keys: LaunchDarklyApiKeys, user: FFUser): Promise<LDFlagSet>;

  /**
   * Update flags by user state
   *
   * @param user - FFUser
   */
  abstract identify(user: FFUser): Promise<LDFlagSet>;
}
